import React from "react";
// Wrapper for check.svg image created for fill and stoke color dynamically set
const CheckIcon = props => {
    const {width, height, color} = props
    return (
        <svg width={width} height={height} viewBox="0 0 115 115" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Check</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Assets_icone" transform="translate(-2533.000000, -6383.000000)" fill={color} fill-rule="nonzero">
                    <g id="chek_per-radiobutton-e-checkbox-copy" transform="translate(2533.000000, 6383.000000)">
                        <g id="icon/blue/check" transform="translate(0.157895, 0.157895)">
                            <g id="espanso" transform="translate(3.279352, 20.769231)">
                                <path d="M36.0728745,76.5182186 C34.6741215,76.5182186 33.2753684,75.9845587 32.2081579,74.9173482 L1.60087045,44.3100607 C-0.533441296,42.1756397 -0.533441296,38.7149393 1.60087045,36.5805182 C3.7352915,34.4462065 7.1959919,34.4462065 9.33041296,36.5805182 L36.0728745,63.3230891 L97.7952024,1.60076113 C99.9296235,-0.533550607 103.390324,-0.533550607 105.524745,1.60076113 C107.659057,3.73518219 107.659057,7.19588259 105.524745,9.33030364 L39.9377004,74.9173482 C38.8703806,75.9845587 37.4716275,76.5182186 36.0728745,76.5182186 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default CheckIcon